import { formatInTimeZone } from 'date-fns-tz';

export const EST_TIMEZONE = 'America/New_York';

/**
 * Format date to YYYY-MM-DD in EST timezone
 * ONLY for display/API formatting - NOT for state storage
 * Uses formatInTimeZone to preserve intended calendar date
 */
export const formatDateEST = (date: Date | null): string => {
  if (!date) return '';
  
  return formatInTimeZone(date, EST_TIMEZONE, 'yyyy-MM-dd');
};
